module.exports = __webpack_public_path__ + "static/media/volume.44b3f22a.svg";